import { useContext, useEffect, useMemo, useState } from 'react'

import {
  Accordion,
  Box,
  Slider,
  Spinner,
  Tabs,
  Text,
} from '@fairfashion/design-system'
import { useParams } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { BackButton } from '../../components/BackButton/back-button.comp'
import { Card } from '../../components/Card/card.comp'
import { OrdersTab } from '../OriginInvoice/components/OrdersTab/orders-tab.comp'
import { SKUTab } from '../OriginInvoice/components/SKUTab/sku-tab.comp'
import {
  OriginInvoiceContext,
  OriginInvoiceProvider,
} from '../OriginInvoice/origin-invoice.context'

import { getInvoiceCardProps } from './origin-invoice.utils'

const OriginInvoiceViewComp = () => {
  const params = useParams()

  const [tab, setTab] = useState<string>('Visualização por SKU')

  const {
    invoice,
    invoiceStatistics,
    invoiceStatisticsData,
    actions,
    loading,
    error,
  } = useContext(OriginInvoiceContext)

  const getInvoice = () => {
    if (params.providerTaxId && params.invoiceCode) {
      actions.getInvoice(params.providerTaxId, params.invoiceCode)
    }
  }
  useEffect(() => {
    getInvoice()
  }, [])

  useEffect(() => {
    if (invoice && !error) {
      actions.getInvoiceStatistics(invoice.id)
      actions.getInvoiceStatisticsData(invoice.id)
    }
  }, [invoice])

  const cardsProps = useMemo(
    () => getInvoiceCardProps(invoiceStatistics, invoiceStatisticsData),
    [invoiceStatistics, invoiceStatisticsData],
  )
  const theme = useTheme()

  return loading ? (
    <Box width="100%" padding={3} justifyContent="center">
      <Spinner size="40px" />
    </Box>
  ) : (
    <Box width="100%" direction="column" gap={3} padding={3}>
      <BackButton url={`/invoices/${params.providerTaxId}`} />
      {error && (
        <Box
          flex={1}
          direction="column"
          alignItems="center"
          padding={8}
          width="100%"
          backgroundColor="white"
          borderRadius={theme.border_radius.box}
          border={{
            color: 'grey_5',
            width: 1,
          }}
          boxShadow={theme.box_shadow.card}
        >
          <Text color="error" align="center">
            {error}
          </Text>
        </Box>
      )}
      {invoice && cardsProps && !error && (
        <>
          <Accordion
            open
            header={
              <Box gap={1} flexWrap="wrap">
                <Box
                  alignItems="center"
                  gap={1}
                  paddingRight={3}
                  maxWidth="100%"
                >
                  <Text size="small" color="grey_3">
                    Nome do Fornecedor
                  </Text>
                  <Text>{invoice.providerName}</Text>
                </Box>
                <Box alignItems="center" gap={1}>
                  <Text size="small" color="grey_3">
                    Nº da NF
                  </Text>
                  <Text>{invoice.code}</Text>
                </Box>
              </Box>
            }
          >
            <Box
              backgroundColor="grey_5"
              borderRadius={theme.border_radius.box}
              padding={3}
              width="100%"
            >
              <Slider buttonPosition="side" sizeToScroll={200}>
                {cardsProps.map((props, index) => (
                  <Card {...props} key={`card-${index}`} />
                ))}
              </Slider>
            </Box>
          </Accordion>
          <Box width="100%" direction="column" gap={3}>
            <Tabs
              tabs={[
                'Visualização por SKU',
                'Visualização por Ordens de Compra',
              ]}
              active={tab}
              onChangeTab={(_tab) => setTab(_tab)}
            />
            <Box width="100%">
              {tab === 'Visualização por SKU' && <SKUTab />}
              {tab === 'Visualização por Ordens de Compra' && <OrdersTab />}
            </Box>
          </Box>
        </>
      )}
    </Box>
  )
}

export const OriginInvoiceView = () => {
  return (
    <OriginInvoiceProvider>
      <OriginInvoiceViewComp />
    </OriginInvoiceProvider>
  )
}
